export default function LocalBusinessSchema() {

  const schema = {
    "@context": "https://schema.org",

    "@graph": [

      {
        "@type": [
  "Organization",
  "ProfessionalService"
],

        "@id": "https://almondsoftwares.in/#organization",

        "name": "Almond Softwares",

        "url": "https://almondsoftwares.in",

        "logo": "https://almondsoftwares.in/logo192.png",

        "image": "https://almondsoftwares.in/logo192.png",

        "description":
          "Almond Softwares is a software development company founded by Lucky Ali Memon specializing in React, Shopify, Salesforce, Android apps and custom software solutions.",


        "telephone": "+917898272840",

        "email": "luckymemon02@gmail.com",


        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Raipur",
          "addressRegion": "Chhattisgarh",
          "postalCode": "492001",
          "addressCountry": "IN"
        },


        "areaServed": [
          "Raipur",
          "Bhilai",
          "Nagpur",
          "Mumbai",
          "Delhi",
          "India"
        ],


      "founder":{
 "@id":"https://almondsoftwares.in/founder#lucky-ali-memon"
}

,
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Software Development Services",

          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Website Development"
              }
            },

            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "React Development"
              }
            },

            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Shopify Development"
              }
            },

            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Salesforce Development"
              }
            }
          ]
        },


        "priceRange": "$$",

        "sameAs": []
      },
{
 "@type":"Person",

 "@id":"https://almondsoftwares.in/founder#lucky-ali-memon",

 "name":"Lucky Ali Memon",

 "jobTitle":"Founder",

 "description":
 "Lucky Ali Memon is the founder of Almond Softwares, a software development company specializing in Salesforce development, React applications, Shopify ecommerce solutions, Android applications and custom software solutions.",


 "url":"https://almondsoftwares.in/founder",


 "worksFor":{
   "@id":"https://almondsoftwares.in/#organization"
 },


 "knowsAbout":[
   "Salesforce Development",
   "React Development",
   "Shopify Development",
   "Android Application Development",
   "Software Engineering"
 ],


 "sameAs":[
   "https://www.linkedin.com/in/luckyali47"
 ]
}

    ]
  };


  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema)
      }}
    />
  );
}